<template>
  <div>
    <el-menu
      :default-active="$route.path"
      :unique-opened="true"
      class="el-menu-vertical-demo"
    >
      <MenuItem
        v-for="(route, index) in menuList"
        :key="index"
        :item="route"
        :fatherPath="route.routerUrl"
      ></MenuItem>
    </el-menu>
  </div>
</template>


<script>
import MenuItem from "./MenuItem.vue";
export default {
  components: {
    MenuItem,
  },
  data() {
    return {
      menuList: [],
    };
  },
  mounted() {
    this.menuList = this.$store.state.menus
  },


};
</script>

<style lang="less" scoped>
.el-menu-vertical-demo{
  height: calc(100vh - 50px);
  overflow-y: auto;
}
</style>
